import 'reflect-metadata';
import * as Sentry from '@sentry/vue';

import '@ui/globals.css';
import 'markdown-it-steps/style.css';
import twMergeDirective from 'tailwind-merge-vue-directive';
import { createApp } from 'vue';

import App from './App.vue';
import plugins from './plugins';
import router from './router';

// Conditional Mirage setup for tests only
if (import.meta.env.DEV && import.meta.env.STUUT_USE_MIRAGE === 'true') {
  const { setupMirage } = await import('./mirage-setup');
  setupMirage();
}

// Reload the page when a dynamically imported chunk fails to load (e.g. after a deploy)
window.addEventListener('vite:preloadError', () => {
  const reloadedKey = 'vite-chunk-reloaded';
  if (!sessionStorage.getItem(reloadedKey)) {
    sessionStorage.setItem(reloadedKey, '1');
    window.location.reload();
  }
});

const app = createApp(App);

if (process.env.STUUT_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: process.env.STUUT_SENTRY_DSN,
    environment: process.env.NODE_ENV || 'development',
  });
}

app.use(plugins);
app.use(router);
app.use(twMergeDirective);

app.directive('visible', (el, binding) => {
  el.style.visibility = binding.value ? 'visible' : 'hidden';
});

app.mount('#app');
